/**
 * Returns the current Italian football season label like "2025/26".
 * Season spans July–June: anything from July (month 7) onward starts
 * the new season named after the current year.
 */
export function currentSeason(short = true, now = new Date()) {
  const month = now.getMonth(); // 0-indexed: 0=Jan … 6=Jul
  const year = now.getFullYear();
  const startYear = month >= 6 ? year : year - 1;
  const endYear = startYear + 1;
  if (short) {
    const endShort = String(endYear).slice(-2);
    return `${startYear}/${endShort}`;
  }
  return `${startYear}/${endYear}`;
}
